// prettier-ignore
// @ts-ignore
import { mergeDefaultChartjsOptions } from "@pureprofile/access-dashboards-react-components";
import * as React from "react";
import * as ReactDOM from "react-dom";

export const renderChartToDom = (
  ReactElement: React.ReactElement<any>,
  id: string | HTMLElement
) => {
  const el = typeof id === "string" ? document.getElementById(id) : id;
  mergeDefaultChartjsOptions();
  ReactDOM.render(ReactElement, el);
};
